import { httpV2 } from "../http";

const base = "/identity-verifications";

const IdentityVerificationService = {
  listStatuses: async (guestReservationIds) => {
    const response = await httpV2.post(`${base}/statuses`, {
      guest_reservation_ids: guestReservationIds,
    }, { timeout: 15000 });
    return response.data;
  },
  getStatus: async (guestReservationId) => {
    const response = await httpV2.get(`${base}/status/${guestReservationId}`);
    return response.data;
  },

  createWorkspaceToken: async (guestReservationId, reason = "initial") => {
    const response = await httpV2.post(
      `${base}/verifications/${guestReservationId}/workspace-token`,
      { reason },
    );
    return response.data;
  },

  refreshStatus: async (guestReservationId) => {
    const response = await httpV2.post(
      `${base}/status/${guestReservationId}/refresh`,
    );
    return response.data;
  },
};

export default IdentityVerificationService;
